<template>
    <div class="resumeOther professional">
        <h1>技能</h1>
        <!--技能非编辑状态-->
        <div v-for="(item,index) in resumeInfo.professionalList">
            <!--<span>{{item.lang}}</span><el-rate v-model="item.level"></el-rate>-->
        </div>

        <!--技能编辑状态-->
        <div>
            <el-form ref="skillForm" :model="skillForm" :rules="rules">
                <el-form-item label="技能" prop="lang">
                    <el-input
                            v-model="skillForm.lang"
                            placeholder="请输入技能"
                            maxlength="30">
                    </el-input>
                </el-form-item>
                <el-form-item label="掌握程度" prop="level">
                    <el-radio v-model="skillForm.level" label="0" border>一般</el-radio>
                    <el-radio v-model="skillForm.level" label="1" border>良好</el-radio>
                    <el-radio v-model="skillForm.level" label="2" border>熟练</el-radio>
                    <el-radio v-model="skillForm.level" label="3" border>精通</el-radio>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" round @click="saveSkill()">保存</el-button>
                    <el-button type="primary" round >取消</el-button>
                </el-form-item>
            </el-form>
        </div>


        <h1>语言</h1>
        <div>
            <el-form ref="languageForm" :model="languageForm" :rules="rules">
                <el-form-item label="语言" prop="lang">
                    <el-input
                            v-model="languageForm.lang"
                            placeholder="请输入语言"
                            maxlength="30">
                    </el-input>
                </el-form-item>
                <el-form-item label="掌握程度" prop="level">
                    <el-radio v-model="languageForm.level" label="0" border>一般</el-radio>
                    <el-radio v-model="languageForm.level" label="1" border>良好</el-radio>
                    <el-radio v-model="languageForm.level" label="2" border>熟练</el-radio>
                    <el-radio v-model="languageForm.level" label="3" border>精通</el-radio>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" round @click="saveLanguage()">保存</el-button>
                    <el-button type="primary" round >取消</el-button>
                </el-form-item>
            </el-form>
        </div>


    </div>
</template>
<script>
    import {saveProfessional} from '@/api/resume';
    export default {
        name: 'professional',
        props: ['resumeInfo'],
        data () {
            return {
                skillForm: {
                    level: '2',
                },
                languageForm: {
                    level: '2',
                },
                rules: {
                    lang: [
                        {required: true, message: '请输入技能/语言'},
                        {max: 30},
                    ],
                    level: [
                        {required: true, message: '请选择掌握程度'},
                    ]
                }
            }
        },
        methods: {
            // 保存掌握技能
            saveSkill(){
                this.$refs["skillForm"].validate(valid=>{
                    if (valid) {
                        this.skillForm.resumeId = this.resumeInfo.id;
                        this.skillForm.professionalType = 0;
                        this.saveProfessional(this.skillForm);
                    }
                })
            },
            // 保存掌握语言
            saveLanguage(){
                this.$refs["languageForm"].validate(valid=>{
                    if (valid) {
                        this.languageForm.resumeId = this.resumeInfo.id;
                        this.languageForm.professionalType = 1;
                        this.saveProfessional(this.languageForm);
                    }
                })
            },
            saveProfessional(form) {
                saveProfessional(form).then(res=>{

                }).catch(()=>{
                    this.$message.error("简历技能/语言保存失败");
                })
            }
        }
    }
</script>
